module.exports = __webpack_public_path__ + "static/media/track.5240ce3d.webp";